var _rect, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBtnAbout(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 61,
    height: 60,
    viewBox: "0 0 61 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.1875,
    width: 60,
    height: 60,
    rx: 8,
    fill: "#E9ECEF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.0972 22.1054C24.0972 26.0228 27.2519 29.2106 31.1284 29.2106C35.005 29.2106 38.1597 26.0228 38.1597 22.1054C38.1597 18.188 35.005 15.0001 31.1284 15.0001C27.2519 15.0001 24.0972 18.188 24.0972 22.1054ZM43.6284 45.0001H45.1909V43.4212C45.1909 37.328 40.2831 32.3685 34.2534 32.3685H28.0034C21.9722 32.3685 17.0659 37.328 17.0659 43.4212V45.0001H43.6284Z",
    fill: "#3F698B"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBtnAbout);
export default __webpack_public_path__ + "static/media/btn-about.60f96c48fd799c39cf4358de4479f112.svg";
export { ForwardRef as ReactComponent };